import React, { useEffect, useState } from 'react';
import UpArrow from '../../../assets/images/Up Arrow.svg';
import DownArrow from '../../../assets/images/Down Arrow.svg';
import DownloadFile from '../../../assets/images/Download File.svg';
import FullScreen from '../../../assets/images/full-screen (3) 1.svg';
import MinimizeScreen from '../../../assets/images/minimize-solid.svg';
import ChartComponent from '../../../components/AreaChart';
import { Button, Dialog, DialogContent, Skeleton } from '@mui/material';
import { useHook as equipmentHook } from './useHook';
import { useParams } from 'react-router-dom';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs, { Dayjs } from 'dayjs';
import CSVExportBtn from '../../../components/CSVExportBtn/index';

// Define the data type for the chart data
interface DataPoint {
  name: string;
  w: number;
}

// Define the tooltip prop types
interface CustomToolTipProps {
  active?: boolean;
  payload?: { value: number }[];
  label?: string;
}

interface ReadableParameterListProps {
  equipmentDetailsData: any;
  setRefreshFunction?: (func: () => void) => void;
  collapseView?: boolean;
}
const ReadableParameterList: React.FC<ReadableParameterListProps> = ({
  equipmentDetailsData,
  setRefreshFunction,
  collapseView,
}) => {
  const {
    fetchReadTimeSerieseParameter,
    fetchDealerReadTimeSerieseParameter,
    fetchReadUnitParameter,
    fetchDealerReadUnitParameter,
  } = equipmentHook();
  const { id } = useParams();
  const userRole = localStorage.getItem('role');
  const [ParameterList, setParameterList] = useState<any[]>([]);
  const [chardViewAccess, setChardViewAccess] = useState(true);
  const [chartData, setChartData] = useState<any>([]);
  const [selectParamData, setSelectParamData] = useState<any>(null);
  const [readUnitParameterData, setReadUnitParameterData] = useState<any>({});
  const [openExpandPopup, setOpenExpandPopup] = useState(false);
  const [startDateValue, setStartDateValue] = React.useState<Dayjs | any>(
    dayjs().startOf('day'),
  );
  const [endDateValue, setEndDateValue] = React.useState<Dayjs | any>(dayjs());
  const [csvChartData, setCsvChartData] = useState<any>([]);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [expandStartDateOpen, setExpandStartDateOpen] = useState(false);
  const [expandEndDateOpen, setExpandEndDateOpen] = useState(false);
  const [loadingChart, setLoadingChart] = useState(true);
  // const initialData = [
  //   { time: new Date(2023, 5, 1, 14).getTime() / 1000, value: 50 }, // June is month 5 (zero-based index)
  //   { time: new Date(2023, 5, 3, 4).getTime() / 1000, value: 55 },
  //   { time: new Date(2023, 5, 3, 5).getTime() / 1000, value: 60 },
  //   { time: new Date(2023, 6, 6, 1).getTime() / 1000, value: 65 }, // July is month 6 (zero-based index)
  //   { time: new Date(2023, 6, 6, 2).getTime() / 1000, value: 70 },
  // ];

  useEffect(() => {
    if (setRefreshFunction) {
      setRefreshFunction(handleRefreshFunction);
    }
  }, [setRefreshFunction]);

  useEffect(() => {
    const windowHeight = window.innerHeight;
    const resultHeight = windowHeight - 200;

    // Set the CSS variable dynamically on the root element
    document.documentElement.style.setProperty(
      '--result-height',
      `${resultHeight}px`,
    );
  }, []);

  //chartdata timeconvert
  function adjustForLocalTimeZone(timestamp: number) {
    const date = new Date(timestamp * 1000); // Convert to milliseconds
    const localOffset = date.getTimezoneOffset() * 60; // Time zone offset in seconds
    return timestamp - localOffset; // Adjust timestamp to match local time
  }
  //csvChartData timeconvert
  const formatTime = (timestamp: number) => {
    if (timestamp) {
      return dayjs.unix(timestamp).format('DD MMM YYYY h:mm:ss A');
    }
  };

  // Generate data from start to end date
  const generateChartData = (start: any, end: any) => {
    const data: { time: any; value: any }[] = [];

    for (let timestamp: any = start; timestamp <= end; timestamp += 3600) {
      //3600 seconds in a hour
      // 86400 seconds in a day
      data.push({
        time: timestamp,
        value: NaN, // Placeholder value, can be replaced or filled with actual data later
      });
    }

    return data;
  };

  // Function to merge and remove duplicates
  function mergeAndRemoveDuplicates(original: any, newEntries: any) {
    // Combine the original and new data
    const combined = [...original, ...newEntries];
    // Create a map to keep the most recent value for each time
    const uniqueMap = new Map();

    combined.forEach((entry) => {
      if (
        !uniqueMap.has(entry.time) ||
        uniqueMap.get(entry.time).timestamp < entry.timestamp
      ) {
        uniqueMap.set(entry.time, entry);
      }
    });

    // Convert the map values to an array
    return Array.from(uniqueMap.values());
  }

  const expandScreenPopup = () => {
    setOpenExpandPopup(true);
  };
  const handleClose = () => {
    setOpenExpandPopup(false);
  };

  //selectParam
  const handleSelectParam = (data: any) => {
    setSelectParamData(data);
    getChartData(data, startDateValue, endDateValue);
  };

  const callAgainChartData = async (
    variableName: any,
    startDateTime: any,
    endDateTime: any,
    generateDummyChartData: any,
    renderChartData: any,
    renderCsvChartData: any,
  ) => {
    const payload = {
      unitID: id,
      from: startDateTime,
      to: endDateTime,
      // limit: 7,
      variable: variableName || '',
    };
    await fetchReadTimeSerieseParameter(payload)
      .then((response: any) => {
        if (response?.data) {
          const chartData = response?.data?.map((data: any) => ({
            time: adjustForLocalTimeZone(data?.timestamp),
            value: data?.value,
          }));
          const csvChartData = response?.data
            ?.map((item: any) => ({
              ...item,
              time: formatTime(item?.timestamp),
            }))
            .sort(
              (a: { timestamp: number }, b: { timestamp: number }) =>
                a.timestamp - b.timestamp,
            );
          const callAgainRenderData = [...renderChartData, ...chartData];
          const callAgainRenderCsvData = [
            ...renderCsvChartData,
            ...csvChartData,
          ];
          if (
            response?.endTime !== payload?.to &&
            response?.endTime < payload?.to
          ) {
            callAgainChartData(
              variableName,
              payload?.from,
              response?.startTime,
              generateDummyChartData,
              callAgainRenderData,
              callAgainRenderCsvData,
            );
          } else {
            const finalChartData = mergeAndRemoveDuplicates(
              callAgainRenderData,
              generateDummyChartData,
            )?.sort(
              (a: { time: number }, b: { time: number }) => a.time - b.time,
            );
            setCsvChartData(callAgainRenderCsvData);
            setChartData(finalChartData);
            setLoadingChart(false);
          }
        }
      })
      .catch(() => {
        setLoadingChart(false);
      });
  };

  const callAgainDealerChartData = async (
    variableName: any,
    startDateTime: any,
    endDateTime: any,
    generateDummyChartData: any,
    renderChartData: any,
    renderCsvChartData: any,
  ) => {
    const payload = {
      unitID: id,
      from: startDateTime,
      to: endDateTime,
      // limit: 7,
      variable: variableName || '',
    };
    await fetchDealerReadTimeSerieseParameter(payload)
      .then((response: any) => {
        if (response?.data) {
          const chartData = response?.data?.map((data: any) => ({
            time: adjustForLocalTimeZone(data?.timestamp),
            value: data?.value,
          }));
          const csvChartData = response?.data
            ?.map((item: any) => ({
              ...item,
              time: formatTime(item?.timestamp),
            }))
            .sort(
              (a: { timestamp: number }, b: { timestamp: number }) =>
                a.timestamp - b.timestamp,
            );
          const callAgainRenderData = [...renderChartData, ...chartData];
          const callAgainRenderCsvData = [
            ...renderCsvChartData,
            ...csvChartData,
          ];
          if (
            response?.endTime !== payload?.to &&
            response?.endTime < payload?.to
          ) {
            callAgainDealerChartData(
              variableName,
              payload?.from,
              response?.startTime,
              generateDummyChartData,
              callAgainRenderData,
              callAgainRenderCsvData,
            );
          } else {
            const finalChartData = mergeAndRemoveDuplicates(
              callAgainRenderData,
              generateDummyChartData,
            )?.sort(
              (a: { time: number }, b: { time: number }) => a.time - b.time,
            );
            setCsvChartData(callAgainRenderCsvData);
            setChartData(finalChartData);
            setLoadingChart(false);
          }
        }
      })
      .catch(() => {
        setLoadingChart(false);
      });
  };

  const getChartData = async (
    data: any,
    startDateTime: any,
    endDateTime: any,
  ) => {
    const payload = {
      unitID: id,
      from: startDateTime?.unix() || null,
      to: endDateTime?.unix() || null,
      // limit: 7,
      variable: data?.variableName || '',
    };
    setLoadingChart(true);
    if (userRole === 'dealer') {
      await fetchDealerReadTimeSerieseParameter(payload)
        .then((response: any) => {
          if (response?.data) {
            const generateDummyChartData = generateChartData(
              startDateTime?.unix(),
              endDateTime?.unix(),
            );
            const chartData = response?.data?.map((data: any) => ({
              time: adjustForLocalTimeZone(data?.timestamp),
              value: data?.value,
            }));

            const csvChartData = response?.data
              ?.map((item: any) => ({
                ...item,
                time: formatTime(item?.timestamp),
              }))
              .sort(
                (a: { timestamp: number }, b: { timestamp: number }) =>
                  a.timestamp - b.timestamp,
              );

            if (
              response?.endTime !== payload?.to &&
              response?.endTime < payload?.to
            ) {
              callAgainDealerChartData(
                data?.variableName,
                payload?.from,
                response?.startTime,
                generateDummyChartData,
                chartData,
                csvChartData,
              );
            } else {
              const finalChartData = mergeAndRemoveDuplicates(
                chartData,
                generateDummyChartData,
              )?.sort(
                (a: { time: number }, b: { time: number }) => a.time - b.time,
              );
              setCsvChartData(csvChartData);
              setChartData(finalChartData);
              setLoadingChart(false);
            }
          } else {
            console.error('Unexpected response format:', response);
            const generateDummyChartData = generateChartData(
              startDateTime?.unix(),
              endDateTime?.unix(),
            );
            const finalChartData = mergeAndRemoveDuplicates(
              [],
              generateDummyChartData,
            )?.sort(
              (a: { time: number }, b: { time: number }) => a.time - b.time,
            );
            setChartData(finalChartData);
            setCsvChartData([]);
            setLoadingChart(false);
          }
          const paramPayload = JSON.stringify({
            from: startDateTime || null,
            to: endDateTime || null,
            variable: data,
          });
          sessionStorage.setItem('paramPayload', paramPayload);
        })
        .catch((error) => {
          console.log(error.message, 'errormessage');
          setLoadingChart(false);
        });
    } else {
      await fetchReadTimeSerieseParameter(payload)
        .then((response: any) => {
          if (response?.data) {
            const generateDummyChartData = generateChartData(
              startDateTime?.unix(),
              endDateTime?.unix(),
            );
            const chartData = response?.data?.map((data: any) => ({
              time: adjustForLocalTimeZone(data?.timestamp),
              value: data?.value,
            }));

            const csvChartData = response?.data
              ?.map((item: any) => ({
                ...item,
                time: formatTime(item?.timestamp),
              }))
              .sort(
                (a: { timestamp: number }, b: { timestamp: number }) =>
                  a.timestamp - b.timestamp,
              );

            if (
              response?.endTime !== payload?.to &&
              response?.endTime < payload?.to
            ) {
              callAgainChartData(
                data?.variableName,
                payload?.from,
                response?.startTime,
                generateDummyChartData,
                chartData,
                csvChartData,
              );
            } else {
              const finalChartData = mergeAndRemoveDuplicates(
                chartData,
                generateDummyChartData,
              )?.sort(
                (a: { time: number }, b: { time: number }) => a.time - b.time,
              );
              setCsvChartData(csvChartData);
              setChartData(finalChartData);
              setLoadingChart(false);
            }
          } else {
            console.error('Unexpected response format:', response);
            const generateDummyChartData = generateChartData(
              startDateTime?.unix(),
              endDateTime?.unix(),
            );
            const finalChartData = mergeAndRemoveDuplicates(
              [],
              generateDummyChartData,
            )?.sort(
              (a: { time: number }, b: { time: number }) => a.time - b.time,
            );
            setChartData(finalChartData);
            setCsvChartData([]);
            setLoadingChart(false);
          }
          const paramPayload = JSON.stringify({
            from: startDateTime || null,
            to: endDateTime || null,
            variable: data,
          });
          sessionStorage.setItem('paramPayload', paramPayload);
        })
        .catch((error) => {
          console.log(error.message, 'errormessage');
          setLoadingChart(false);
        });
    }
  };

  //Get ReadUnitParameter
  const getreadUnitParameter = async () => {
    if (userRole === 'dealer') {
      await fetchDealerReadUnitParameter({ unitID: id })
        .then((response) => {
          setReadUnitParameterData(response);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      await fetchReadUnitParameter({ unitID: id })
        .then((response) => {
          setReadUnitParameterData(response);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const chartColors = {
    backgroundColor: 'white',
    lineColor: '#2B7FFF',
    textColor: 'black',
    areaTopColor: 'rgb(35 119 252)',
    areaBottomColor: 'rgb(35 119 252 / 0%)',
  };

  const handleZoomFunction = (data: any) => {
    console.log(data, 'zooming data from parend');
  };

  const handleDragFunction = (data: any) => {
    console.log(data, 'Drag data from parend');
  };

  useEffect(() => {
    if (equipmentDetailsData) {
      setParameterList(equipmentDetailsData?.readableParameters || []);
    }
  }, [equipmentDetailsData]);

  useEffect(() => {
    if (equipmentDetailsData?.readableParameters?.length > 0) {
      // Retrieve the JSON string from sessionStorage
      const paramPayload = sessionStorage.getItem('paramPayload');

      // Parse the JSON string to an object, or set to null if parsing fails
      const paramPayloadObject = paramPayload ? JSON.parse(paramPayload) : null;
      if (paramPayloadObject) {
        handleRefreshFunction();
      } else {
        setSelectParamData(equipmentDetailsData?.readableParameters[0]);
        setStartDateValue(dayjs().startOf('day'));
        setEndDateValue(dayjs());
        getChartData(
          equipmentDetailsData?.readableParameters[0],
          dayjs().startOf('day'),
          dayjs(),
        );
      }
      getreadUnitParameter();
    }
  }, [equipmentDetailsData, id]);

  const handleSubmitTime = () => {
    if (dayjs(startDateValue).isValid() && dayjs(endDateValue).isValid()) {
      getChartData(selectParamData, startDateValue, endDateValue);
    }
  };

  const handleStartDateTimeChange = (newValue: any) => {
    const currentTime = dayjs();
    if (newValue && dayjs(newValue).isAfter(currentTime)) {
      setStartDateValue(dayjs().startOf('day')); // Set to current time if greater than current time
    } else {
      setStartDateValue(newValue);
    }

    if (
      endDateValue &&
      newValue &&
      dayjs(newValue).isAfter(dayjs(endDateValue))
    ) {
      setEndDateValue(null); // Reset end time if start time exceeds it
      setStartDateValue(dayjs().startOf('day')); // Set to current time if greater than current time
    }
  };
  const handleEndDateTimeChange = (newValue: any) => {
    const currentTime = dayjs();
    if (
      startDateValue &&
      newValue &&
      dayjs(newValue).isBefore(dayjs(startDateValue))
    ) {
      setEndDateValue(null);
    } else if (newValue && dayjs(newValue).isAfter(currentTime)) {
      setEndDateValue(currentTime); // Set to current time if greater than current time
    } else {
      setEndDateValue(newValue);
    }
  };

  const shouldDisableStartDate = (date: {
    isAfter: (arg0: any) => any;
    isBefore: (arg0: dayjs.Dayjs) => any;
  }) => {
    if (!endDateValue) {
      return false; // No startDate selected, so don't disable any dates
    }
    return date.isAfter(endDateValue);
  };

  //csv file downloader
  const csvHeader = [
    { label: 'Time', key: 'time' },
    { label: 'Value', key: 'value' },
  ];

  const handleRefreshFunction = () => {
    // Retrieve the JSON string from sessionStorage
    const paramPayload = sessionStorage.getItem('paramPayload');

    // Parse the JSON string to an object, or set to null if parsing fails
    const paramPayloadObject = paramPayload ? JSON.parse(paramPayload) : null;

    // Check if paramPayloadObject is valid and contains valid date fields
    if (paramPayloadObject) {
      const fromDate = paramPayloadObject.from
        ? dayjs(paramPayloadObject.from)
        : null;
      const toDate = paramPayloadObject.to
        ? dayjs(paramPayloadObject.to)
        : null;
      // Validate date fields
      if (fromDate && fromDate?.isValid() && toDate && toDate?.isValid()) {
        // Set state values with the retrieved data
        setSelectParamData(paramPayloadObject?.variable);
        setStartDateValue(fromDate);
        setEndDateValue(toDate);

        // Fetch chart data with the retrieved parameters
        getChartData(paramPayloadObject?.variable, fromDate, toDate);
      }
    }
  };

  const findReadParamValue = (paramName: any) => {
    for (let i = 0; i < readUnitParameterData?.length; i++) {
      if (readUnitParameterData[i][paramName] !== undefined) {
        return readUnitParameterData[i][paramName];
      }
    }
    return null; // Return null if varname not found
  };

  const findReadParamTimestamp = (paramName: any) => {
    for (let i = 0; i < readUnitParameterData?.length; i++) {
      if (readUnitParameterData[i][paramName] !== undefined) {
        return readUnitParameterData[i].timestamp;
      }
    }
    return null; // Return null if varname not found
  };

  return ParameterList?.length > 0 ? (
    <section className="equipment_information">
      <h5>Readable Parameter List</h5>
      <p>
        Last Updated on{' '}
        {formatTime(findReadParamTimestamp(selectParamData?.variableName))}
      </p>
      <div className="equipment_information-content equipment_parameter_list">
        <div className="equipment_parameter_list-card_container">
          {equipmentDetailsData?.readableParameters?.map(
            (data: any, index: number) => (
              <Button
                key={index}
                className={
                  data?.parameterName === selectParamData?.parameterName
                    ? 'equipment_parameter_list-card equipment_parameter_list-card-active'
                    : ' equipment_parameter_list-card'
                }
                onClick={() => handleSelectParam(data)}
              >
                <div className="equipment_parameter_list-card-value">
                  <div>
                    <h5>
                      {findReadParamValue(data?.variableName)?.toFixed(
                        data.decimals,
                      ) || ''}
                    </h5>
                    <h5>{data?.unit || ''}</h5>
                  </div>

                  {/* <img
                    src={
                      readUnitParameterData?.[data?.parameterName]
                        ? UpArrow
                        : DownArrow
                    }
                    alt="arrow"
                    width="20"
                  /> */}
                </div>

                <h6>{data?.parameterName || ' '}</h6>
              </Button>
            ),
          )}
        </div>

        <div className="equipment_parameter_list-chart_container">
          <h5>{selectParamData?.parameterName || ' '}</h5>
          <div className="equipment_parameter_list-chart-card">
            <header className="equipment_parameter_list-chart-card_header">
              <div className="equipment_parameter_list-chart-card_header-timepicker">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    value={startDateValue}
                    onChange={handleStartDateTimeChange}
                    shouldDisableDate={shouldDisableStartDate}
                    maxDateTime={dayjs()}
                    open={startDateOpen}
                    onOpen={() => setStartDateOpen(true)}
                    onClose={() => setStartDateOpen(false)}
                    slotProps={{
                      textField: {
                        onClick: () => setStartDateOpen(true),
                      },
                      popper: {
                        modifiers: [
                          {
                            name: 'flip',
                            enabled: false,
                          },
                          {
                            name: 'preventOverflow',
                            options: {
                              altBoundary: true,
                              tether: false,
                              rootBoundary: 'viewport',
                            },
                          },
                        ],
                      },
                    }}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    value={endDateValue}
                    onChange={handleEndDateTimeChange}
                    disabled={!startDateValue}
                    minDateTime={startDateValue && startDateValue}
                    maxDateTime={dayjs()}
                    open={endDateOpen}
                    onOpen={() => setEndDateOpen(true)}
                    onClose={() => setEndDateOpen(false)}
                    slotProps={{
                      textField: {
                        onClick: () => setEndDateOpen(true),
                      },
                      popper: {
                        modifiers: [
                          {
                            name: 'flip',
                            enabled: false,
                          },
                          {
                            name: 'preventOverflow',
                            options: {
                              altBoundary: true,
                              tether: false,
                              rootBoundary: 'viewport',
                            },
                          },
                        ],
                      },
                    }}
                  />
                </LocalizationProvider>
                <Button
                  className="parameter_time_popup-submit"
                  onClick={handleSubmitTime}
                  disabled={
                    !dayjs(startDateValue).isValid() ||
                    !dayjs(endDateValue).isValid() ||
                    !selectParamData
                  }
                >
                  Submit
                </Button>
              </div>

              <div className="equipment_parameter_list-chart-card_header-btn_container">
                <CSVExportBtn
                  headers={csvHeader}
                  csvData={csvChartData ? csvChartData : []}
                  label={<img src={DownloadFile} alt="arrow" width="20" />}
                  prifix="_readable_parameter"
                />
                {/* <Button>
                  <img src={DownloadFile} alt="arrow" width="20" />
                </Button> */}
                {/* <Button>
                  <img src={Capture} alt="arrow" width="20" />
                </Button> */}
                <Button onClick={expandScreenPopup}>
                  <img src={FullScreen} alt="arrow" width="20" />
                </Button>
              </div>
            </header>
            <div className="equipment_parameter_list-chart-card-data">
              {loadingChart ? (
                <Skeleton
                  variant="rectangular"
                  sx={{ borderRadius: '10px' }}
                  width={'100%'}
                  height={'100%'}
                />
              ) : (
                <ChartComponent
                  handleZoomFunction={handleZoomFunction}
                  handleDragFunction={handleDragFunction}
                  colors={chartColors}
                  data={chartData}
                  collapseView={collapseView}
                ></ChartComponent>
              )}
            </div>
          </div>
        </div>

        <Dialog
          fullScreen
          className="expand-popup"
          open={openExpandPopup}
          onClose={handleClose}
          aria-labelledby="delete-dialog-title"
          aria-describedby="delete-dialog-description"
          fullWidth
          maxWidth="xl"
          sx={{
            '& .MuiDialog-paper': {
              borderRadius: '0px',
              height: '100vh',
              width: '100vw',
              margin: 0,
              padding: 0,
            },
          }}
        >
          <DialogContent>
            <div className="equipment_parameter_list-chart_container">
              <div className="equipment_parameter_header">
                <h5>{selectParamData?.parameterName || ' '}</h5>
              </div>

              <div className="equipment_parameter_list-chart-card">
                <header className="equipment_parameter_list-chart-card_header">
                  <div className="equipment_parameter_list-chart-card_header-timepicker">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        value={startDateValue}
                        onChange={handleStartDateTimeChange}
                        shouldDisableDate={shouldDisableStartDate}
                        maxDateTime={dayjs()}
                        open={expandStartDateOpen}
                        onOpen={() => setExpandStartDateOpen(true)}
                        onClose={() => setExpandStartDateOpen(false)}
                        slotProps={{
                          textField: {
                            onClick: () => setExpandStartDateOpen(true),
                          },
                          popper: {
                            modifiers: [
                              {
                                name: 'flip',
                                enabled: false,
                              },
                              {
                                name: 'preventOverflow',
                                options: {
                                  altBoundary: true,
                                  tether: false,
                                  rootBoundary: 'viewport',
                                },
                              },
                            ],
                          },
                        }}
                      />
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        value={endDateValue}
                        onChange={handleEndDateTimeChange}
                        disabled={!startDateValue}
                        minDateTime={startDateValue && startDateValue}
                        maxDateTime={dayjs()}
                        open={expandEndDateOpen}
                        onOpen={() => setExpandEndDateOpen(true)}
                        onClose={() => setExpandEndDateOpen(false)}
                        slotProps={{
                          textField: {
                            onClick: () => setExpandEndDateOpen(true),
                          },
                          popper: {
                            modifiers: [
                              {
                                name: 'flip',
                                enabled: false,
                              },
                              {
                                name: 'preventOverflow',
                                options: {
                                  altBoundary: true,
                                  tether: false,
                                  rootBoundary: 'viewport',
                                },
                              },
                            ],
                          },
                        }}
                      />
                    </LocalizationProvider>
                    <Button
                      className="parameter_time_popup-submit"
                      onClick={handleSubmitTime}
                      disabled={
                        !dayjs(startDateValue).isValid() ||
                        !dayjs(endDateValue).isValid() ||
                        !selectParamData
                      }
                    >
                      Submit
                    </Button>
                  </div>

                  <div className="equipment_parameter_list-chart-card_header-btn_container">
                    <CSVExportBtn
                      headers={csvHeader}
                      csvData={csvChartData ? csvChartData : []}
                      label={<img src={DownloadFile} alt="arrow" width="20" />}
                      prifix="_readable_parameter"
                    />

                    <Button onClick={handleClose}>
                      <img src={MinimizeScreen} alt="arrow" width="20" />
                    </Button>
                  </div>
                </header>
                <div className="equipment_parameter_list-chart-card-data">
                  {loadingChart ? (
                    <Skeleton
                      variant="rectangular"
                      sx={{ borderRadius: '10px' }}
                      width={'100%'}
                      height={'100%'}
                    />
                  ) : (
                    <ChartComponent
                      handleZoomFunction={handleZoomFunction}
                      handleDragFunction={handleDragFunction}
                      colors={chartColors}
                      data={chartData}
                    ></ChartComponent>
                  )}
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </section>
  ) : (
    <></>
  );
};

const MemoizedComponent = React.memo(ReadableParameterList);
export default MemoizedComponent;
